import React from "react";
import { Video } from "lucide-react";

/**
 * Featured video card — Facebook oEmbed placed above the Windy radar so users
 * land on eye-catching surf footage first. The iframe is boxed inside an
 * aspect-video wrapper so it stays 16:9 across desktop, tablet and phone
 * without getting cropped.
 */
export default function FeaturedVideo() {
  return (
    <section
      id="featured-video"
      data-testid="featured-video"
      className="clay p-4 sm:p-5 mb-6 scroll-mt-24"
    >
      <div className="flex items-center gap-2 mb-3">
        <div
          className="w-9 h-9 rounded-2xl flex items-center justify-center shrink-0"
          style={{ background: "var(--coral)" }}
        >
          <Video className="w-4 h-4 text-white" />
        </div>
        <div>
          <p className="eyebrow text-[color:var(--coral)]">Featured surf clip</p>
          <h3 className="font-bold text-base sm:text-lg leading-tight" style={{ fontFamily: "Outfit" }}>
            Watch this before you check the radar
          </h3>
        </div>
      </div>
      <div className="rounded-2xl overflow-hidden bg-black aspect-video relative">
        <iframe
          src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fsurfranchpopoyo%2Fvideos%2F683307325845718%2F&show_text=false&width=560&t=0"
          title="Surf Ranch Popoyo — featured surf clip"
          className="absolute inset-0 w-full h-full"
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
          data-testid="featured-video-iframe"
        />
      </div>
    </section>
  );
}
